import { FlexColumn, FlexRow, LabeledInput, MaterialIcon, useLoading } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { useMemo, useState } from 'react';
import { FEEDBACK, FEEDBACK_PREFIXES } from '../../constants/app';
import { useFeedback } from '../../hooks/useFeedback';
import { useStyles } from '../../hooks/useStyles';
import { postDevicesBrand } from '../../services/deviceService';
import { DeviceBrand } from '../../types/deviceBrand';
import StyledTooltip from '../ui/StyledTooltip';

type Props = {
  onCancel: () => void;
  afterSave: (brandId: string) => void;
};
export function DevicesBrandForm({ onCancel, afterSave }: Props) {
  const { css } = useStyles();
  const [editingDevicesBrand, setEditingDevicesBrand] = useState<DeviceBrand>({
    _id: '',
    name: '',
  });
  const { startLoading, stopLoading, loading } = useLoading(false);
  const { showFailFeedback, showPositiveFeedback } = useFeedback();

  const canSubmit = useMemo(() => {
    return !!editingDevicesBrand.name;
  }, [editingDevicesBrand]);

  const onInputChange = (value: string | undefined | null, field: keyof DeviceBrand) => {
    setEditingDevicesBrand((prev) => ({ ...prev!, [field]: value }));
  };

  const onSave = async () => {
    startLoading();
    const { id, error } = await postDevicesBrand(editingDevicesBrand);
    if (!error && id) {
      afterSave(id);
      showPositiveFeedback(FEEDBACK.created(FEEDBACK_PREFIXES.deviceBrand));
    } else {
      showFailFeedback(error || FEEDBACK.failedCreation(FEEDBACK_PREFIXES.deviceBrand));
    }
    stopLoading();
  };

  return (
    <FlexColumn
      classNames={css({
        justifyContent: 'space-between',
        overflow: 'hidden',
        width: '100%',
        flexDirection: 'row',
        alignItems: 'end',
      })}
    >
      <FlexColumn
        classNames={css({
          overflow: 'auto',
          width: '100%',
          height: '100%',
        })}
      >
        <LabeledInput
          label={`(Nueva Marca) Nombre:`}
          value={editingDevicesBrand?.name}
          onChange={(value) => onInputChange(value, 'name')}
          required
        />
      </FlexColumn>
      <FlexRow gap={0}>
        <StyledTooltip
          content={'Cancelar'}
          showArrow={false}
        >
          <Button
            size="compact"
            shape="square"
            onClick={onCancel}
            kind="tertiary"
          >
            <MaterialIcon name={'cancel'} />
          </Button>
        </StyledTooltip>
        <StyledTooltip
          content={'Guardar'}
          showArrow={false}
        >
          <Button
            size="compact"
            shape="square"
            onClick={onSave}
            isLoading={loading}
            disabled={!canSubmit}
            kind="tertiary"
          >
            <MaterialIcon name={'done'} />
          </Button>
        </StyledTooltip>
      </FlexRow>
    </FlexColumn>
  );
}
